<template>
  <div
    :class="wrpCls"
    class="headerRight"
  >
    <div class="workspace-identity">
      <span class="workspace-dot"></span>
      <span>{{ workspaceName }}</span>
      <img v-if="isTrue && userInfo.mark" @click="sysOpen" src="@/assets/success.png" alt="" />
      <img @click="sysOpen" v-if="!isTrue && userInfo.mark" src="@/assets/error.png" alt="" />
    </div>

    <span v-if="!isMobile" class="header-time">{{ timeArry.timeText }} {{ timeArry.week }}</span>
    <a-icon
      title="视频教程"
      type="video-camera"
      class="header-action-icon"
      @click="showVideoTree"
    />
    <operation :menu="showMenu" :class="prefixCls" />
    <Contact :menu="showMenu" :class="prefixCls" />
    <Search :menu="showMenu" :class="prefixCls" />
    <Notice :menu="showMenu" :class="prefixCls" />
    <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
    <sys-com ref="sysComRef" :sysInfo="sysInfo"></sys-com>
    <videoPlay ref="videoPlayRef" @close="modalVisible = false"></videoPlay>
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown'
import Contact from './contact'
import Search from './search'
import Guanwang from './guanwang'
import Notice from './Notice'
import SelectLang from '@/components/SelectLang'
import Operation from './operation.vue'
import videoPlay from './video.vue'

import storage from 'store'
import { initSystemStatus } from '@/api/login.js'
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/formatDate'
import SysCom from './sysCom.vue'
export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    Contact,
    Guanwang,
    Notice,
    Search,
    SelectLang,
    Operation,
    SysCom,
    videoPlay,
  },

  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action',
    },
    isMobile: {
      type: Boolean,
      default: () => false,
    },
    topMenu: {
      type: Boolean,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showMenu: true,
      timer: null,
      timeArry: '',
      currentUser: {},
      name: undefined,
      storeName: undefined,
      sysInfo: {},
      isTrue: false,
      videoData: [],
      modalVisible: false,
    }
  },
  created() {
    this.name = storage.get('tenantName')
    this.storeName = storage.get('storeNameOne')
    this.timeArry = formatDate(new Date())
    this.timeStart()
  },
  computed: {
    workspaceName() {
      return [this.name, this.storeName].filter(Boolean).join(' · ') || '零售经营工作台'
    },
    wrpCls() {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${this.isMobile || !this.topMenu ? 'light' : this.theme}`]: true,
      }
    },
    ...mapGetters(['userInfo']),
  },
  mounted() {
    this.getInitSystemStatus()
    // this.handleSearch()
    setTimeout(() => {
      this.currentUser = { ...this.$store.state.user }
    }, 1500)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },

  methods: {
    // handleSearch() {
    //   treeAll({ pageNo: 1, pageSize: 999 }).then((res) => {
    //     this.videoData = res.data
    //   })
    // },

    showVideoTree() {
      // this.handleSearch()
      this.$refs.videoPlayRef.visible = true
    },
    sysOpen() {
      this.$refs.sysComRef.visible = true
    },
    getInitSystemStatus() {
      initSystemStatus().then((res) => {
        this.sysInfo = res.data
        this.isTrue = Object.keys(this.sysInfo).every((key) => {
          return this.sysInfo[key] === true
        })
        console.log(this.isTrue, 312312)
      })
    },
    timeStart() {
      // 设置定时器
      this.timer = setInterval(() => {
        this.timeArry = formatDate(new Date())
      }, 1000)
    },
  },
}
</script>
<style lang="less" scoped>
.headerRight {
  display: flex;
  height: 56px;
  padding-left: 0;
  color: #344054;
  align-items: center;
  justify-content: center;

  .workspace-identity {
    position: absolute;
    left: 82px;
    display: flex;
    max-width: 360px;
    overflow: hidden;
    color: #344054;
    font-size: 14px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
    align-items: center;

    .workspace-dot {
      width: 7px;
      height: 7px;
      margin-right: 9px;
      background: #23b26d;
      border-radius: 50%;
      box-shadow: 0 0 0 4px rgba(35, 178, 109, 0.1);
    }

    img {
      width: 17px;
      height: 17px;
      margin-left: 8px;
      cursor: pointer;
    }
  }

  .header-time {
    margin-right: 18px;
    color: #7b8494;
    font-size: 13px;
  }

  .header-action-icon {
    margin-right: 8px;
    padding: 10px;
    color: #667085;
    font-size: 18px;
    border-radius: 9px;
    cursor: pointer;
    transition: 0.2s ease;

    &:hover {
      color: #315efb;
      background: #eef2ff;
    }
  }
}

@media screen and (max-width: 900px) {
  .headerRight .workspace-identity {
    display: none;
  }
}

@media screen and (max-width: 570px) {
  .headerRight {
    height: 56px;
  }
}
</style>
